// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".assets-scss-gridstyleGrid-container-ftoxy{margin:0 auto;max-width:1536px;padding:0 12px;width:100%}.assets-scss-gridstyleGrid-grid-jqgwn{display:grid;grid-gap:24px;grid-template-columns:repeat(12,1fr)}.assets-scss-gridstyleGrid-col6-bgrzk{grid-column:span 6}.assets-scss-gridstyleGrid-col3-ieueb{grid-column:span 3}.assets-scss-gridstyleGrid-col4-xvofn{grid-column:span 4}.assets-scss-gridstyleGrid-col9-tlavz{grid-column:span 9}.assets-scss-gridstyleGrid-col12-eqmdd{grid-column:span 12}.assets-scss-gridstyleGrid-alignItemsStart-vstrx{align-items:start}", ""]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": "assets-scss-gridstyleGrid-container-ftoxy",
	"grid": "assets-scss-gridstyleGrid-grid-jqgwn",
	"col6": "assets-scss-gridstyleGrid-col6-bgrzk",
	"col3": "assets-scss-gridstyleGrid-col3-ieueb",
	"col4": "assets-scss-gridstyleGrid-col4-xvofn",
	"col9": "assets-scss-gridstyleGrid-col9-tlavz",
	"col12": "assets-scss-gridstyleGrid-col12-eqmdd",
	"alignItemsStart": "assets-scss-gridstyleGrid-alignItemsStart-vstrx"
};
module.exports = ___CSS_LOADER_EXPORT___;
